var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.545 5.001L7.636 5.001C7.25046 5.00126 6.88078 5.15454 6.60816 5.42716C6.33554 5.69978 6.18226 6.06946 6.182 6.455L6.182 10.819H9.091V9.364L12 11.546L9.091 13.728L9.091 12.274H6.182V16.638C6.182 17.0239 6.33529 17.394 6.60816 17.6668C6.88103 17.9397 7.25111 18.093 7.637 18.093H18.545C18.7362 18.093 18.9254 18.0553 19.102 17.9821C19.2786 17.909 19.4391 17.8017 19.5742 17.6665C19.7093 17.5313 19.8165 17.3708 19.8895 17.1941C19.9626 17.0175 20.0001 16.8282 20 16.637V6.455C20 6.06911 19.8467 5.69903 19.5738 5.42616C19.301 5.15329 18.9309 5 18.545 5V5.001ZM16.364 15.183H13.455V13.728H16.364V15.183ZM18.546 12.274L13.455 12.274V10.819L18.546 10.819V12.274ZM18.546 9.365L13.455 9.365V7.91H18.546V9.364V9.365ZM6.182 12.274H4L4 10.819H6.182L6.182 12.274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostJob);
export default __webpack_public_path__ + "static/media/Post_job.28a2461d5d2a1371ec9616c5bd80b9b4.svg";
export { ForwardRef as ReactComponent };